import React from 'react';

const ContactModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleCall = () => {
    window.location.href = 'tel:+919654495307';
  };

  const handleWhatsApp = () => {
    window.open('https://wa.me/919654495307', '_blank');
  };

  const handleMapClick = () => {
    const address = "1st Floor, Plot-60, Aakriti Eco City Rd, Rohit Nagar, Akriti, Salaiya, Bhopal, Madhya Pradesh 462039";
    window.open(`https://maps.app.goo.gl/8UCFxac7bxHciPc78`, '_blank');
  };

  return (
    <div className="modal-overlay" id="contact" onClick={handleOverlayClick}>
      <div className="modal-content">
        <div className="modal-header">
          <h1>Contact Us</h1>
          <button className="modal-close" onClick={onClose}>
            ×
          </button>
        </div>
        
        <div className="modal-body">
          <div className="contact-section">
            <div className="contact-icon">
              📞
            </div>
            <div className="contact-info">
              <h2>Call Us</h2>
              <p className="contact-number">+91 9654495307</p>
              <div className="contact-actions">
                <button className="call-btn" onClick={handleCall}>
                  📞 Call Now
                </button>
                <button className="whatsapp-btn" onClick={handleWhatsApp}>
                  💬 WhatsApp
                </button>
              </div>
            </div>
          </div>

          <div className="contact-section">
            <div className="contact-icon">
              📍
            </div>
            <div className="contact-info">
              <h2>Visit Us</h2>
              <p className="contact-address">
                1st floor, 60, Akriti Ecocity Road, Akriti Ecocity,<br />
                Bawadiya Kalan, Bhopal
              </p>
              <button className="map-btn" onClick={handleMapClick}>
                🗺️ View on Map
              </button>
            </div>
          </div>

          <div className="contact-section">
            <div className="contact-icon">
              ⏰
            </div>
            <div className="contact-info">
              <h2>Working Hours</h2>
              <p className="contact-hours">
                Tuesday - Saturday: 6:00 PM - 8:00 PM<br />
                Sunday: 10:00 AM - 6:00 PM
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactModal;